import Vue from "vue";
import QuantificationTransformer from "@/transformers/purchase/quantification";
import errorHandler from "@/utils/errorHandler";

// Currently only used to pass sinister from VaCo to LV. Frontend is validating VaCo total with Sinister total
// Send prop deletd_concepts always equal to []
export default (affectedId, payload) => {
  const transformed = QuantificationTransformer.send({
    ...payload,
    deletedConcepts: null,
  });

  const request = Vue.$http.post(
    `purchase/quantification/${affectedId}/`,
    transformed
  );
  return errorHandler(request).then((response) => {
    const data = response.data;
    return data;
  });
};



// WEBPACK FOOTER //
// ./src/services/purchase/sendQuantification.js